var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CampusRank",style:({'height':_vm.height+'px'})},[_c('div',{staticClass:"titlegaga"},[_vm._v("设备类型消费饼状图(本月)  单位:万元")]),_c('div',{attrs:{"id":"PieMonth"}})])}
var staticRenderFns = []

export { render, staticRenderFns }